import { notEmptyValidation } from "security-app/components/common/FormUtils/commonValidations";
export const INIT_EVENT_PROCEDURE = {
  title: "",
  description: "",
  steps: [],
  share_request: {}
};
export const validateTitle = (value) => notEmptyValidation(value) ? void 0 : "Title is required";
export const validations = (values) => {
  const errors = {};
  const invalidTitle = validateTitle(values.title);
  if (invalidTitle) errors.title = invalidTitle;
  return errors;
};
